import { UserSettings } from 'src/Libs/user/types'
import { ChartSettings } from 'src/Libs/chart-kit'

/***
 * Settings for all charts which are edited by the user via the system chart editor.
 */
export const getChartsEditingSettings = (userSettings?: UserSettings): ChartSettings[] =>
  userSettings?.chartConfig?.map(config => {
    try {
      return JSON.parse(config)
    } catch (err) {
      console.log(err)
      return {}
    }
  }) ?? []
